module.exports = __webpack_public_path__ + "assets/images/project/head/Kamal_Singh.jpg?v=b2614be6";